import React from "react";

import { UserAuth } from "./useAuth";

export const AuthContext = React.createContext<UserAuth>({
  authSession: null,
  isUserLoggedIn: false,
  setAuthSession: () => ({}),
});
